import React, { useMemo } from 'react'
import './App.css'

const App = () => {
  const [weight, setWeight] = React.useState(70)
  const [height, setHeight] = React.useState(180)

  const output = useMemo(() => {
    const heightInMeters = height / 100;
    // to fixed is used to round the number to 2 decimal places
    return (weight / heightInMeters ** 2).toFixed(1)
  }, [weight, height])


  return (
    <main>
      <h1>BMI CALCULATOR</h1>
      <div className="input-section">
        <p className='slider-output'>Weight: {weight} kg</p>
        <input
          className='input-slider'
          type="range"
          //step is the increment value
          step={1}
          min={40}
          max={200}
          value={weight}
          onChange={(e) => setWeight(e.target.value)}
        />

        <p className='slider-output'>Height: {height} cm</p>
        <input
          className='input-slider'
          type="range"
          step={1}
          min={140}
          max={220}
          value={height}
          onChange={(e) => setHeight(e.target.value)}
        />
      </div>

      {/* output section */}
      <div className="output-section">
        <p>
          Your BMI is
        </p>
        <div className={`output ${output < 18.5 ? "yellow" : output < 24.9 ? "green" : output < 30 ? "yellow" : "red"
          }`}>{output}</div>
      </div>
    </main>
  )
}

export default App